import { theme } from 'styles/theme/theme';
export type Background = { name: string; value: string };

export const backgroundColors: Record<number, Background> = {
  0: { name: 'Прозрачный', value: 'transparent' },
  1: { name: 'Синий', value: theme.colors.SurfaceRaisinBlack50 },
  2: { name: 'Белый', value: theme.colors.SurfaceWhite },
};

export const backgrounds: Background[] = [
  { name: 'Прозрачный', value: 'transparent' },
  { name: 'Синий', value: theme.colors.SurfaceRaisinBlack50 },
  { name: 'Белый', value: theme.colors.SurfaceWhite },
];
